import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {RolePermission } from '../../shared/models/role.permission.enum';
import { LeadService } from '../services/lead.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';

@Component({
  selector: 'app-add',
  templateUrl: './add.component.html',
  styleUrls: ['./add.component.scss']
})
export class AddComponent extends AbstractBiditComponent implements OnInit {
  constructor(private router: Router, deviceDetectorService: DeviceDetectorService) {
    super(deviceDetectorService);
  }

  ngOnInit() {
    let canAdd = LeadService.hasPermission(RolePermission.AddLead);
    if (!canAdd) {
      this.router.navigate(['/lead/']);
    }
  }
}
